module.exports = __webpack_public_path__ + "media/images/recruit/section/mv_department_sp12-aec2ed23b4e8ebe1ba23912e2cb87fa0.jpg";